import { getAxiosInstance } from '../../configs/axios-config';
import { authDetails } from '../../helpers/auth-details';
var constants = require("../../configs/constants");
const ADD_BRANCH_PROFILE_PROGRESS = "ADD_BRANCH_PROFILE_PROGRESS";
const ADD_BRANCH_PROFILE_SUCCESS = "ADD_BRANCH_PROFILE_SUCCESS";
const ADD_BRANCH_PROFILE_FAILURE = "ADD_BRANCH_PROFILE_FAILURE";
const SOCIETY_PHOTO_SUCCESS = "SOCIETY_PHOTO_SUCCESS";
const SEND_BRANCH_CASE = "SEND_BRANCH_CASE";
const DELETE_SOCIETY_DATA = "DELETE_SOCIETY_DATA";
const LOADING_SO_IN_PROGRESS = "LOADING_SO_IN_PROGRESS";
const FETCH_SOCIETY_PROFILE_SUCCESS = "FETCH_SOCIETY_PROFILE_SUCCESS";
const FETCH_SOCIETY_PROFILE_FAILURE = "FETCH_SOCIETY_PROFILE_FAILURE";
const HIDE_SOCIETY_PROFILE_SNACKBAR = "HIDE_SOCIETY_PROFILE_SNACKBAR";
const LOADING_SO_DIALOG_IN_PROGRESS = "LOADING_SO_DIALOG_IN_PROGRESS";

export const hideSnackBarAction = () => { return { type: HIDE_SOCIETY_PROFILE_SNACKBAR } }
export const loadingInProgress = () => { return { type: LOADING_SO_IN_PROGRESS } }
export const loadingDialogInProgress = () => { return { type: LOADING_SO_DIALOG_IN_PROGRESS } }
export const addSocietyProfileInProgress = () => { return { type: ADD_BRANCH_PROFILE_PROGRESS } }
export const addSocietyProfileSuccess = (successMessage) => { return { type: ADD_BRANCH_PROFILE_SUCCESS, message: successMessage } }
export const addSocietyProfileFailure = (errorMessage) => { return { type: ADD_BRANCH_PROFILE_FAILURE, message: errorMessage } }
export const returnSwitch = (caseData, edit, profileDetails) => { return { type: SEND_BRANCH_CASE, caseData: caseData, edit: edit, profileDetails: profileDetails } }
export const addPhotoSuccess = (photoUrl, successMsg) => { return { type: SOCIETY_PHOTO_SUCCESS, photoUrl: photoUrl, successMsg: successMsg } }
export const deleteSocietySuccess = (successMsg) => { return { type: DELETE_SOCIETY_DATA, message: successMsg } }
export const deleteSocietyFailure = (errorMsg) => { return { type: DELETE_SOCIETY_DATA, message: errorMsg } }
export const fetchSocietyProfileSuccess = (data) => { return { type: FETCH_SOCIETY_PROFILE_SUCCESS, data: data } }
export const fetchSocietyProfileFailure = (errorMessage) => { return { type: FETCH_SOCIETY_PROFILE_FAILURE, message: errorMessage } }

// HIDE THE MESSAGE SNACKBAR
export const hideSnackBar = () => (dispatch) => {
    dispatch(hideSnackBarAction());
}

// RENDER COMPONENT USING SWITCH CASE
export const renderSwitch = (caseData, edit, profileDetails) => (dispatch) => {
    dispatch(returnSwitch(caseData, edit, profileDetails));
};

// GET SOCIETY PROFILES
export const fetchProfiles = () => (dispatch) => {
    dispatch(loadingDialogInProgress());
    var user = authDetails();
    let axiosInstance = getAxiosInstance();
    return axiosInstance.get(constants.api.SOCIETY + '/' + user._id, {
    }).then(function (response) {
        dispatch(fetchSocietyProfileSuccess(response.data));
    }).catch(function (error) {
        dispatch(fetchSocietyProfileFailure(error.message));
    });
};

// POST SOCIETY PROFILE PHOTO
export const uploadFile = (image) => (dispatch) => {
    dispatch(loadingInProgress());
    let bodyFormData = new FormData();
    bodyFormData.append('file', image.societyProfile);
    const config = {
        headers: { 'content-type': 'multipart/form-data' }
    }

    let axiosInstance = getAxiosInstance();
    return axiosInstance.post(constants.api.UPLOAD, bodyFormData, config
    ).then(function (response) {
        dispatch(addPhotoSuccess(response.data.secureUrl, "प्रोफाइल फोटो यशस्वीरित्या अपलोड केला आहे"));
    }).catch(function (error) {
        dispatch(addSocietyProfileFailure(error.message));
    });
};

// POST SOCIETY DETAILS
export const addSocietyProfile = (branchProfileData) => (dispatch) => {
    var user = authDetails();
    let axiosInstance = getAxiosInstance();

    dispatch(addSocietyProfileInProgress());
    return axiosInstance.post(constants.api.SO_SOCIETY, {
        societyName: branchProfileData.allData.societyName,
        societyShortName: branchProfileData.allData.societyShortName,
        phoneNumber: branchProfileData.allData.phoneNumber,
        mobileNumber: branchProfileData.allData.mobileNumber,
        address: branchProfileData.allData.address,
        village: branchProfileData.allData.village,
        grade: branchProfileData.allData.grade,
        pincode: branchProfileData.allData.pincode,
        registrationNumber: branchProfileData.allData.registrationNumber,
        registrationDate: branchProfileData.allData.registrationDate,
        societyType: branchProfileData.allData.societyTypeNumber,
        gstNumber: branchProfileData.allData.gstNumber,
        societyProfile: branchProfileData.societyProfile,
        arId: user.addedBy,
        addedBy: user._id,
    }).then(function (response) {
        dispatch(addSocietyProfileSuccess(response.data.message));
    }).catch(function (error) {
        dispatch(addSocietyProfileFailure(error.response.data.message));
    });
};

// Edit SOCIETY DETAILS
export const editSocietyProfile = (branchProfileData) => (dispatch) => {
    var user = authDetails();
    let axiosInstance = getAxiosInstance();

    dispatch(addSocietyProfileInProgress());
    return axiosInstance.put(constants.api.SO_SOCIETY, {
        societyName: branchProfileData.societyName,
        societyShortName: branchProfileData.societyShortName,
        phoneNumber: branchProfileData.phoneNumber,
        mobileNumber: branchProfileData.mobileNumber,
        address: branchProfileData.address,
        village: branchProfileData.village,
        taluka: branchProfileData.taluka,
        district: branchProfileData.district,
        state: branchProfileData.state,
        grade: branchProfileData.grade,
        pincode: branchProfileData.pincode,
        registrationNumber: branchProfileData.registrationNumber,
        registrationDate: branchProfileData.registrationDate,
        societyType: branchProfileData.societyTypeNumber,
        societyProfile: branchProfileData.societyProfile,
        id: branchProfileData.id,
        gstNumber: branchProfileData.gstNumber,
        arId: user.addedBy,
        addedBy: user._id,
    }).then(function (response) {
        dispatch(addSocietyProfileSuccess(response.data.message));
    }).catch(function (error) {
        dispatch(addSocietyProfileFailure(error.response.data.message));
    });
};

// DELETE SOCIETY DETAILS
export const deleteSociety = (userId) => (dispatch) => {
    let axiosInstance = getAxiosInstance();
    return axiosInstance.patch(constants.api.SO_SOCIETY + '/' + userId).then(function (response) {
        dispatch(deleteSocietySuccess(response.data.message));
    }).catch(function (error) {
        dispatch(deleteSocietyFailure(error.message));
    });
}

export const initialState = {
    inProgress: false,
    message: '',
    open: false,
    edit: false,
    add: false,
    choice: 'branch',
    profileDetails: {},
    profileData: {},
    photoUrl: null,
    loading: false,
    loadingDialog: false
}

export default (state = initialState, action) => {
    switch (action.type) {
        case ADD_BRANCH_PROFILE_PROGRESS:
            return { ...state, inProgress: true };
        case ADD_BRANCH_PROFILE_SUCCESS:
            return { ...state, message: action.message, inProgress: false, choice: 'branch', open: true, add: true };
        case ADD_BRANCH_PROFILE_FAILURE:
            return { ...state, message: action.message, inProgress: false, open: true, loading: false };
        case DELETE_SOCIETY_DATA:
            return { ...state, message: action.message, open: true };
        case LOADING_SO_DIALOG_IN_PROGRESS:
            return { ...state, loadingDialog: true };
        case FETCH_SOCIETY_PROFILE_SUCCESS:
            return { ...state, profileData: action.data, add: false, loadingDialog: false };
        case FETCH_SOCIETY_PROFILE_FAILURE:
            return { ...state, loadingDialog: false };
        case LOADING_SO_IN_PROGRESS:
            return { ...state, loading: true };
        case SOCIETY_PHOTO_SUCCESS:
            return { ...state, photoUrl: action.photoUrl, message: action.successMsg, open: true, loading: false };
        case SEND_BRANCH_CASE:
            return { ...state, choice: action.caseData, edit: action.edit, profileDetails: action.profileDetails };
        case HIDE_SOCIETY_PROFILE_SNACKBAR:
            return { ...state, open: false };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/society/branch-table-reducer.js